<!-- d-none d-lg-inline-block -->
@if (isMobile) {
  <div class="row pt-4">
    <div class="col-auto">
      <button class="btn btn-light border-dark-subtle" (click)="open(content)">
        <i class="fa-solid fa-bars fa-xl me-2"></i>
        <span class="fw-normal">Menú</span>
      </button>
    </div>
  </div>
}

@if (!isMobile) {
  <div class="sidebar">
    <ng-content select="[sideContent]"></ng-content>
    <div class="row">
      <div class="col-12">
        <h4
          class="text-primary"
          [ngClass]="{ clickable: titleLink }"
          [routerLink]="titleLink"
          [innerHTML]="title"
        ></h4>
      </div>
      @for (item of items; track item; let ind = $index) {
        <div class="col-12">
          @if (item.disabled) {
            <button
              class="sidebar-item"
              [ngClass]="item.separator ? 'mt-3' : 'my-3'"
              [disabled]="item.disabled"
              (click)="handleActive(item, ind)"
              >
              <!-- (ind + 1) > step -->
              <div class="d-flex">
                <span class="text-disabled">
                  <span [innerHTML]="item.name"></span>
                  @if (!item.unable) {
                    <small class="text-primary ms-2"
                      >PRÓXIMAMENTE</small
                      >
                    }
                  </span>
                </div>
              </button>
            } @else {
              @if (item.isFull) {
                <a
                  class="sidebar-item amm-link d-block py-3"
                  [href]="item.isFull"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  <span [innerHTML]="item.name"></span>
                </a>
              }
              @if (item.download) {
                <button
                  class="sidebar-item"
                  [ngClass]="item.separator ? 'mt-3' : 'my-3'"
                  (click)="download(item.download)"
                  >
                  <span [innerHTML]="item.name"></span>
                  <span class="ms-2">
                    <i class="fa-solid fa-download fa-sm"></i>
                  </span>
                </button>
              }
              @if (!item.isFull && !item.download) {
                <button
                  class="sidebar-item"
                  routerLinkActive="text-primary"
                  [ngClass]="item.separator ? 'mt-3' : 'my-3'"
                  [routerLink]="item.link"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [disabled]="!isLogged && !enables.includes(ind + 1)"
                  (click)="handleActive(item, ind)"
                  >
                  <!-- (ind + 1) > step -->
                  <div class="d-flex">
                    <span [innerHTML]="item.name"></span>
                    <span class="ms-2">
                      @if (item.children) {
                        <i
                          class="fa-solid"
                [ngClass]="
                  ind === activeChild ? 'fa-chevron-up' : 'fa-chevron-down'
                "
                        ></i>
                      }
                      @if (!item.children) {
                        <strong>
                          <i class="fa-solid fa-chevron-right fa-sm"></i>
                        </strong>
                      }
                    </span>
                  </div>
                </button>
              }
              @if (item.children) {
                <div
                  #collapse="ngbCollapse"
                  [ngbCollapse]="ind !== activeChild"
                  >
                  <ul class="accordion-list" style="list-style: none">
                    @for (subitem of item.children; track subitem) {
                      <li>
                        <div class="w-100">
                          @if (!subitem.download) {
                            <button
                              [routerLink]="subitem.link"
                              routerLinkActive="text-primary"
                              class="sidebar-item"
                              >
                              <span [innerHTML]="subitem.name"></span>
                            </button>
                          }
                          @if (subitem.download) {
                            <button
                              class="sidebar-item"
                              (click)="download(subitem.download)"
                              >
                              <span [innerHTML]="subitem.name"></span>
                            </button>
                          }
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              }
            }
            @if (item.separator) {
              <hr class="my-4 border-sidebar" />
            }
          </div>
        }
      </div>
    </div>
  }

  <ng-template #content>
    <div class="offcanvas-header px-4 pb-0">
      <h4
        class="offcanvas-title text-primary"
        [ngClass]="{ clickable: titleLink }"
        [routerLink]="titleLink"
        [innerHTML]="title"
      ></h4>

      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()"
      ></button>
    </div>

    <div class="offcanvas-body">
      <ng-content select="[sideContentM]"></ng-content>

      <div class="row">
        @for (item of items; track item; let ind = $index) {
          <div class="col-12">
            @if (item.disabled) {
              <button
                class="sidebar-item"
                [ngClass]="item.separator ? 'mt-3' : 'my-3'"
                [disabled]="item.disabled"
                (click)="handleActive(item, ind)"
                >
                <!-- (ind + 1) > step -->
                <div class="d-flex">
                  <span class="text-disabled">
                    <span [innerHTML]="item.name"></span>
                    @if (!item.unable) {
                      <small class="text-primary ms-2"
                        >PRÓXIMAMENTE</small
                        >
                      }
                    </span>
                  </div>
                </button>
              } @else {
                @if (item.isFull) {
                  <a
                    class="sidebar-item amm-link d-block py-3"
                    [href]="item.isFull"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="close()"
                    >
                    <span [innerHTML]="item.name"></span>
                  </a>
                }
                @if (item.download) {
                  <button
                    class="sidebar-item"
                    [ngClass]="item.separator ? 'mt-3' : 'my-3'"
                    (click)="download(item.download)"
                    >
                    <span [innerHTML]="item.name"></span>
                    <span class="ms-2">
                      <i class="fa-solid fa-download fa-sm"></i>
                    </span>
                  </button>
                }
                @if (!item.isFull && !item.download) {
                  <button
                    class="sidebar-item"
                    routerLinkActive="text-primary"
                    [ngClass]="item.separator ? 'mt-3' : 'my-3'"
                    [routerLink]="item.link"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [disabled]="!isLogged && !enables.includes(ind + 1)"
                    (click)="handleActive(item, ind); close()"
                    >
                    <!-- (ind + 1) > step -->
                    <div class="d-flex">
                      <span [innerHTML]="item.name"></span>
                      <span class="ms-2">
                        @if (item.children) {
                          <i
                            class="fa-solid"
                  [ngClass]="
                    ind === activeChild ? 'fa-chevron-up' : 'fa-chevron-down'
                  "
                          ></i>
                        }
                        @if (!item.children) {
                          <strong>
                            <i class="fa-solid fa-chevron-right fa-sm"></i>
                          </strong>
                        }
                      </span>
                    </div>
                  </button>
                }
                @if (item.children) {
                  <div
                    #collapse="ngbCollapse"
                    [ngbCollapse]="ind !== activeChild"
                    >
                    <ul class="accordion-list" style="list-style: none">
                      @for (subitem of item.children; track subitem) {
                        <li>
                          <div class="w-100">
                            @if (!subitem.download) {
                              <button
                                [routerLink]="subitem.link"
                                routerLinkActive="text-primary"
                                class="sidebar-item"
                                (click)="close()"
                                >
                                <span [innerHTML]="subitem.name"></span>
                              </button>
                            }
                            @if (subitem.download) {
                              <button
                                class="sidebar-item"
                                (click)="download(subitem.download)"
                                >
                                <span [innerHTML]="subitem.name"></span>
                              </button>
                            }
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                }
              }
              @if (item.separator) {
                <hr class="my-4 border-sidebar" />
              }
            </div>
          }
        </div>
      </div>
    </ng-template>
